import { inject, Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Socket, io } from "socket.io-client";
import { SOCKET_EVENTS } from "@global-nodes/user-management/models/socket";
import { ENVIRONMENT } from "../../environments/environments.token";
import { Environment } from "../../environments/environment.interface";

@Injectable({
  providedIn: "root",
})
export class SocketClientService {
  public socketClient!: Socket;
  private env: Environment = inject(ENVIRONMENT);
  private USER_API: string = "";

  constructor() {
    this.USER_API = this.env.USER_API || "";
    this.socketClient = io(this.USER_API);
    this.socketClient.on("connect", () => {
      console.log("Connected to server");
    });
    this.socketClient.on("disconnect", () => {
      console.log("Disconnected from server");
    });
    this.socketClient.on("connect_error", () => {
      console.log("Error connecting to server");
    });
    this.socketClient.on("connect_success", () => {
      console.log("Connected to server");
    });
    this.socketClient.on("connect_complete", () => {
      console.log("Connected to server");
    });
  }

  getMessage() {
    const observable = new Observable<{ user: string; message: string }>(observer => {
      this.socketClient.on("onMessage", data => {
        observer.next(data);
      });
    });
    return observable;
  }

  getUserLoggedInSuccess() {
    return new Observable(observer => {
      this.socketClient.on(SOCKET_EVENTS.LOGIN_SUCCESS, data => {
        observer.next(data);
      });
    });
  }

  removeUserLogin() {
    return new Observable(observer => {
      this.socketClient.on(SOCKET_EVENTS.REMOVE_LOGIN, data => {
        observer.next(data);
      });
    });
  }

  getUserConnected() {
    return new Observable(observer => {
      this.socketClient.on(SOCKET_EVENTS.USER_CONNECTED, data => {
        observer.next(data);
      });
    });
  }
}
